import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-person",
  "use": "icon-person-usage",
  "viewBox": "0 0 2.91 6.61",
  "content": "<symbol viewBox=\"0 0 2.91 6.61\" id=\"icon-person\">\r\n    <path d=\"M2.91,1.91c0,1.28-.09,1.84-.1,2v0a.21.21,0,0,1-.21.21.23.23,0,0,1-.21-.16L2.15,6.32a.32.32,0,0,1-.31.29.3.3,0,0,1-.3-.23V4.23a.09.09,0,0,0-.09-.09.09.09,0,0,0-.08.09V6.39a.31.31,0,0,1-.29.22h0a.31.31,0,0,1-.3-.29h0L.52,3.93a.22.22,0,0,1-.21.16A.21.21,0,0,1,.1,3.88v0c0-.11,0-.67-.1-2a.62.62,0,0,1,.67-.66H.82a.85.85,0,0,0,.65.3.82.82,0,0,0,.43-.12.79.79,0,0,0,.22-.18h.12A.62.62,0,0,1,2.91,1.91ZM2.07.35A.7.7,0,0,0,1.47,0a.73.73,0,0,0-.35.09A.7.7,0,0,0,.87,1L1,1.15a.68.68,0,0,0,.51.23.66.66,0,0,0,.34-.09A.61.61,0,0,0,2,1.17.71.71,0,0,0,2.07.35Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/person.svg
// module id = DBgD
// module chunks = 0